import { writable } from "svelte/store";
const defaultValue = JSON.parse(localStorage.recentExports || "[]");
/** list of recently exported layers */
export const recentExports = writable(defaultValue);
recentExports.subscribe((value) => {
    localStorage.recentExports = JSON.stringify(value);
});
